import React from "react";
import { ChevronRight, ChevronLeft } from "lucide-react";
import type { MindMapNode as NodeType } from "./types";

interface MindMapNodeProps {
  node: NodeType;
  isRoot?: boolean;
  isExpanded?: boolean;
  onToggle: (id: string) => void;
  depth?: number;
}

const depthColors = [
  "bg-purple-accent text-white shadow-[0_4px_14px_-3px_hsl(var(--purple-accent)/0.3)]",
  "bg-blue-accent text-white shadow-[0_4px_14px_-3px_hsl(var(--blue-accent)/0.3)]",
  "bg-teal text-white shadow-[0_4px_14px_-3px_hsl(var(--color-teal)/0.3)]",
  "bg-info text-white shadow-[0_4px_14px_-3px_hsl(var(--color-info)/0.3)]",
  "bg-premium text-white shadow-[0_4px_14px_-3px_hsl(var(--color-premium)/0.3)]",
];

export const MindMapNodeComponent: React.FC<MindMapNodeProps> = ({
  node,
  isRoot = false,
  isExpanded = false,
  onToggle,
  depth = 0,
}) => {
  const hasChildren = !!node.children?.length;
  const colorClass = depthColors[Math.min(depth, depthColors.length - 1)];

  return (
    <button
      data-node-id={node.id}
      onClick={() => hasChildren && onToggle(node.id)}
      className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-full px-3.5 py-1.5 text-[13px] font-medium shadow-md transition-all duration-200 ${colorClass} ${
        hasChildren ? "cursor-pointer hover:-translate-y-0.5 hover:shadow-lg" : "cursor-default"
      } ${isRoot ? "px-5 py-2 text-sm" : ""}`}
    >
      <span className="font-sans">{node.label}</span>
      {hasChildren && (
        isExpanded ? (
          <ChevronLeft className="h-3.5 w-3.5 opacity-70" />
        ) : (
          <ChevronRight className="h-3.5 w-3.5 opacity-70" />
        )
      )}
    </button>
  );
};
